import * as React from 'react';

const CircleMinus: React.FC = () => {
    return (<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" focusable="false"><path fill="none" d="M-2-2h24v24H-2z"/><path fillRule="evenodd" clipRule="evenodd" fill="currentColor" d="M10 0l.28.004C15.673.152 20 4.571 20 10l-.004.28C19.848 15.673 15.429 20 10 20 4.477 20 0 15.523 0 10S4.477 0 10 0zm0 2a8 8 0 000 16l.249-.004A8 8 0 0018 10l-.004-.249A8 8 0 0010 2zm3 7a1 1 0 010 2H7a1 1 0 010-2h6z"/></svg>);
};

export default React.memo(CircleMinus);
